export const ROWS_PER_PAGE_OPTIONS = [8, 12, 20, 32, 100];
